/**
 * Browser download helpers. The Blob + object-URL + anchor-click dance is otherwise
 * inlined across a dozen pages; keep it in one place.
 */

/**
 * Trigger a client-side download of `blob` as `filename`.
 *
 * The anchor is appended to the document before it is clicked — Firefox ignores
 * a click on a detached anchor — and the object URL is revoked on the next tick
 * rather than immediately, because revoking synchronously can beat the browser
 * to reading it.
 */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Trigger a client-side download of `text`. */
export function downloadText(filename: string, text: string, mediaType = 'text/plain;charset=utf-8'): void {
  downloadBlob(filename, new Blob([text], { type: mediaType }));
}

/** Trigger a client-side download of `data` serialized as pretty-printed JSON. */
export function downloadJson(filename: string, data: unknown): void {
  downloadBlob(filename, new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
}
